export const eventNameRegex = /\bname\b:\s*\"(.+?)\"/;
export const eventNameWithDelimiterRegex = /\bname\b:\s*\"(.+?)\"( AND )?/;
export const FREQUENCY_FILTER = 'first_event_for_user:true';
